"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../../io/codec");
var serialiser_1 = require("./../../../serialisers/serialiser");
var service_id_serialiser_1 = require("./../../../services/gateway-control/services/service-id-serialiser");
/**
 * Serialiser for {@link GatewayServiceId}
 */
var GatewayServiceSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayServiceSerialiserClass, _super);
    function GatewayServiceSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayService} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayService} that was read
     */
    GatewayServiceSerialiserClass.prototype.read = function (bis) {
        var id = service_id_serialiser_1.GatewayServiceIdSerialiser.read(bis);
        var desc = Codec.readByte(bis) ? Codec.readString(bis) : undefined;
        var config = Codec.readByte(bis) ? Codec.readString(bis) : undefined;
        return {
            id: id,
            description: desc,
            configuration: config
        };
    };
    /**
     * Write a {@link GatewayService} from the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayService} to write
     */
    GatewayServiceSerialiserClass.prototype.write = function (bos, value) {
        service_id_serialiser_1.GatewayServiceIdSerialiser.write(bos, value.id);
        // tslint:disable-next-line: strict-type-predicates
        if (value.description !== undefined && value.description !== null) {
            Codec.writeByte(bos, 1);
            Codec.writeString(bos, value.description);
        }
        else {
            Codec.writeByte(bos, 0);
        }
        // tslint:disable-next-line: strict-type-predicates
        if (value.configuration !== undefined && value.configuration !== null) {
            Codec.writeByte(bos, 1);
            Codec.writeString(bos, value.configuration);
        }
        else {
            Codec.writeByte(bos, 0);
        }
    };
    return GatewayServiceSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayServiceSerialiserClass = GatewayServiceSerialiserClass;
/**
 * The {@link GatewayServiceSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayServiceSerialiser = new GatewayServiceSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-detail-serialiser.js
// module id = 624
// module chunks = 0